import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=0eca7cb1"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=0eca7cb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports